export {
    default as Template404,
    ITemplate404Props,
} from './404';
